import { renderQuestions } from 'src/components/helpers/renderFormQuestions';
import { weddingFormCoupleQuestions } from '../newRequest/questions/weddingFormCoupleQuestions';
import { useEffect, useState } from 'react';
import { Button } from 'semantic-ui-react';
import weddingRequestService from 'src/services/api/weddingRequestService';
import Swal from 'sweetalert2';

const WeddingRequestEditAnswers = (props) => {
  const { answers, set_inputs, inputs, changeStep, set_editCoupleInfo, getInfo } = props;
  const [dateFocused, set_dateFocused] = useState(null);
  const [errorInputs, setErrorInputs] = useState({});
  const [image, set_image] = useState(false);
  const [loading, set_loading] = useState(false);

  useEffect(() => {
    set_inputs({
      ...inputs,
      coupleQuestions: {
        ...answers?.coupleQuestions,
        photo: answers?.coupleQuestions?.couple_picture,
        captcha: '123',
      },
    });
  }, [answers]);

  const handleInputs = (event) =>
    set_inputs({
      ...inputs,
      coupleQuestions: {
        ...(inputs?.coupleQuestions || {}),
        [event.target.name]: event.target.value,
      },
    });

  const handleSetImage = (file) => {
    set_image(file);
    setErrorInputs((prev) => ({ ...prev, couple_picture: false }));
  };

  const questions = weddingFormCoupleQuestions(inputs?.coupleQuestions);

  const sendForm = () => {
    set_loading(true);

    const data = new FormData();
    data.append('couplePicture', image ? image : null);
    data.append('coupleQuestions', JSON.stringify(inputs?.coupleQuestions));
    data.append('id', answers?.id);
    data.append('male_guest_id', answers?.MaleGuest?.id);
    data.append('female_guest_id', answers?.FemaleGuest?.id);
    data.append('maleGuestIdentification', answers?.MaleGuest?.identification);
    data.append('femaleGuestIdentification', answers?.FemaleGuest?.identification);

    weddingRequestService
      .WeddingEditRequest(data)
      .then((response) => {
        set_loading(false);
        const { success } = response.data || {};
        if (success) {
          set_editCoupleInfo(false);
          getInfo();
        }
        if (response?.data?.message) Swal.fire(response?.data?.message);
      })
      .catch((error) => {
        set_loading(false);
        Swal.fire(error.response?.data?.message || 'Ha ocurrido un error al enviar la solicitud');
      });
  };

  return (
    <div className="form-section">
      {renderQuestions({
        questions,
        inputs: inputs?.coupleQuestions || {},
        changeStep,
        sending: loading,
        handleInputs,
        errorInputs,
        setErrorInputs,
        dateFocused,
        set_dateFocused,
        set_image: handleSetImage,
        image,
      })}
      <Button onClick={(e) => set_editCoupleInfo(false)} disabled={loading}>
        Cancelar
      </Button>
      <Button onClick={(e) => sendForm(e)} primary disabled={loading}>
        Guardar
      </Button>
    </div>
  );
};

export default WeddingRequestEditAnswers;
